export default __webpack_public_path__ + "static/media/voucherGTS4.d7f92fcf.jpg";